module.exports = __webpack_public_path__ + "static/media/d6_logo_support.135f495d.svg";